module.exports = __webpack_public_path__ + "static/media/uvjeti-koristenja-lexhr.10f197b7.pdf";